const getConversationId = (botState) => {
    var _a;
    if (!botState)
        return null;
    const localConversationId = Object.keys(botState).find((key) => key.includes('-'));
    if (localConversationId)
        return localConversationId;
    if (!botState.JWT)
        return null;
    const b64Payload = (_a = botState.JWT) === null || _a === void 0 ? void 0 : _a.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    const decodedPayload = JSON.parse(atob(b64Payload));
    return decodedPayload.clientSessionId;
};

export { getConversationId };
//# sourceMappingURL=getConversationId.js.map
